import(/* webpackMode: "eager" */ "/backpine-learning/app/globals.css");
import(/* webpackMode: "eager" */ "/backpine-learning/components/sentry-provider.tsx");
import(/* webpackMode: "eager" */ "/backpine-learning/components/theme-provider.tsx");
import(/* webpackMode: "eager" */ "/backpine-learning/components/ui/toaster.tsx");
import(/* webpackMode: "eager" */ "/backpine-learning/components/ui/tooltip.tsx")